import React from 'react'
import { cloneDeep } from 'lodash'
import { getDataField } from 'utils/constants/dataFields'
import { OPERATION_TYPES } from 'utils/constants/operationTypes'

import { post, put } from 'services/api'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

import styles from './styles'

export default (props) => {
  const {
    formData,
    updateForm,
    leftQuestionKey,
    rightQuestionKey,
    LeftComponent,
    RightComponent,
  } = props

  const token = useSelector((state) => state.auth.access_token)
  const form_uuid = useSelector((state) => state.form.uuid)
  const forOwner = useSelector((state) => state.form.owner)

  const classes = styles()

  const checkPageCompletion = (data, key) => {
    let question_A
    let question_B
    if (key === leftQuestionKey) {
      question_A = data
    } else {
      question_A = formData[leftQuestionKey]
    }

    if (key === rightQuestionKey) {
      question_B = data
    } else {
      question_B = formData[rightQuestionKey]
    }

    return question_A.has_answer && question_B.has_answer
  }

  const saveAnswer = async (data, key, operationType) => {
    const body = {
      question_name: key,
      [`${getDataField(key)}`]: data[getDataField(key)],
    }
    let res
    if (operationType === OPERATION_TYPES.CREATE) {
      res = await post({
        url: `/due_diligence/pf/form/${form_uuid}/question/answer/submit`,
        data: body,
        token,
      })
    } else {
      res = await put({
        url: `/due_diligence/pf/form/${form_uuid}/question/answer/change`,
        data: body,
        token,
      })
    }

    if (res.status === 400) {
      toast.error(
        'Houve um problema ao salvar a resposta, por favor, tente novamente',
      )
    }
  }

  const saveResponses = async (data, key, operationType) => {
    const isPageComplete = checkPageCompletion(data, key)
    const newFormData = cloneDeep(formData)
    newFormData[key] = data
    await saveAnswer(data, key, operationType).then(() => {
      updateForm(newFormData, isPageComplete)
    })
  }

  return (
    <div className={classes.container}>
      <div className={classes.formWrapper}>
        <div className={classes.formLayout}>
          <div className={classes.formColumn}>
            <LeftComponent
              questionData={formData[leftQuestionKey]}
              saveResponses={saveResponses}
              formOwner={forOwner}
            />
          </div>
          <div className={classes.formColumn}>
            <RightComponent
              questionData={formData[rightQuestionKey]}
              saveResponses={saveResponses}
              formOwner={forOwner}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
